/* eslint-disable unicorn/no-null */
const hasChanges = ref<boolean>(false);
const resetFunction = ref<(() => void) | null>(null);
const saveFunction = ref<(() => Promise<void>) | null>(null);
const isModalOpen = ref(false);
const isLoading = ref(false);
const isSavingDisabled = ref(false);

const modalClosePromise = ref(Promise.resolve());
const modalClosePromiseResolve = ref(() => {
    return;
});
watchEffect(() => {
    if (isModalOpen.value) {
        modalClosePromise.value = new Promise((resolve) => {
            modalClosePromiseResolve.value = resolve;
        });

        return;
    }

    modalClosePromiseResolve.value();
});

// eslint-disable-next-line no-restricted-exports, unicorn/no-anonymous-default-export
export default () => {
    function setHasChanges(value: boolean) {
        hasChanges.value = value;
    }

    function setSaveFunction(function_: () => Promise<void>) {
        saveFunction.value = function_;
    }

    function setResetFunction(function_: () => void) {
        resetFunction.value = function_;
    }

    function setUnsavedChangesHeader(
        value: boolean,
        resetFunction_: (() => void) | undefined,
        saveFunction_: (() => Promise<void>) | undefined,
    ) {
        setHasChanges(value);

        if (resetFunction_) setResetFunction(resetFunction_);
        if (saveFunction_) setSaveFunction(saveFunction_);
    }

    function setIsLoading(newLoadingState: boolean) {
        isLoading.value = newLoadingState;
    }

    function setIsSavingDisabled(newSavingDisabledState: boolean) {
        isSavingDisabled.value = newSavingDisabledState;
    }

    function toggleModal(value: boolean) {
        isModalOpen.value = value;
    }

    return {
        hasChanges,
        isLoading,
        isModalOpen,
        isSavingDisabled,
        modalClosePromise,
        resetFn: resetFunction,
        saveFn: saveFunction,
        setIsLoading,
        setIsSavingDisabled,
        setUnsavedChangesHeader,
        toggleModal,
    };
};
